import type { IndustryDto, SubIndustryDto } from '../../shared/industries/models/industry.models';

const MOCK_INDUSTRIES: IndustryDto[] = [
  { id: '00000000-0000-0000-0000-000000000000', name: 'All' },
  { id: '10000000-0000-4000-8000-000000000002', name: 'Energy' },
  { id: '10000000-0000-4000-8000-000000000003', name: 'Public Sector' },
  { id: '10000000-0000-4000-8000-000000000004', name: 'Retail' },
  { id: '10000000-0000-4000-8000-000000000005', name: 'Transport' },
  { id: '10000000-0000-4000-8000-000000000006', name: 'Others' },
  { id: '10000000-0000-4000-8000-000000000007', name: 'FSI - Banking' },
  { id: '10000000-0000-4000-8000-000000000008', name: 'FSI - Insurance' },
  { id: '10000000-0000-4000-8000-000000000009', name: 'Health' },
  { id: '10000000-0000-4000-8000-00000000000a', name: 'ICP' },
];

const MOCK_SUB_INDUSTRIES: Record<string, SubIndustryDto[]> = {
  '10000000-0000-4000-8000-000000000009': [
    {
      parentId: '10000000-0000-4000-8000-000000000009',
      id: '20000000-0000-4000-8000-000000000032',
      name: 'Pharma and Biotech',
    },
    {
      parentId: '10000000-0000-4000-8000-000000000009',
      id: '20000000-0000-4000-8000-000000000035',
      name: 'Medical Devices',
    },
  ],
  '10000000-0000-4000-8000-000000000002': [
    {
      parentId: '10000000-0000-4000-8000-000000000002',
      id: '20000000-0000-4000-8000-000000000037',
      name: 'Utilities',
    },
  ],
};

export function mockHandleIndustriesRoute(
  method: string,
  canonicalPath: string,
  requestUrl: string,
): { status: number; body: unknown } | null {
  if (method !== 'GET') {
    return null;
  }

  if (canonicalPath === '/api/industries') {
    const includeAll = new URL(requestUrl, 'http://mock').searchParams.get('includeAll') === 'true';
    const industries = includeAll
      ? MOCK_INDUSTRIES
      : MOCK_INDUSTRIES.filter(
          (industry) => industry.id !== '00000000-0000-0000-0000-000000000000',
        );
    return { status: 200, body: industries };
  }

  const subMatch = /^\/api\/industries\/([^/]+)\/sub-industries$/.exec(canonicalPath);
  if (subMatch) {
    const parentId = decodeURIComponent(subMatch[1]);
    if (parentId === '00000000-0000-0000-0000-000000000000') {
      return { status: 200, body: [] };
    }
    return { status: 200, body: MOCK_SUB_INDUSTRIES[parentId] ?? [] };
  }

  return null;
}

export const MOCK_INDUSTRY_ALL = MOCK_INDUSTRIES[0];
export const MOCK_INDUSTRY_ENERGY = MOCK_INDUSTRIES[1];
export const MOCK_INDUSTRY_PUBLIC = MOCK_INDUSTRIES[2];
export const MOCK_INDUSTRY_RETAIL = MOCK_INDUSTRIES[3];
export const MOCK_INDUSTRY_TRANSPORT = MOCK_INDUSTRIES[4];
export const MOCK_INDUSTRY_OTHER = MOCK_INDUSTRIES[5];
export const MOCK_INDUSTRY_FSI_BANKING = MOCK_INDUSTRIES[6];
export const MOCK_INDUSTRY_FSI_INSURANCE = MOCK_INDUSTRIES[7];
export const MOCK_INDUSTRY_HEALTH = MOCK_INDUSTRIES[8];
export const MOCK_INDUSTRY_ICP = MOCK_INDUSTRIES[9];

const LEGACY_INDUSTRY_NAME_ALIASES: Readonly<Record<string, string>> = {
  transportation: 'Transport',
  'cross-industry': 'Others',
  'cross industry': 'Others',
  others: 'Others',
  public: 'Public Sector',
  'fsi – banking': 'FSI - Banking',
  'fsi - banking': 'FSI - Banking',
  'fsi – insurance': 'FSI - Insurance',
  'fsi - insurance': 'FSI - Insurance',
};

export function mockIndustryDtoByName(name: string): IndustryDto {
  const normalized = name.trim().toLowerCase();
  const canonical = LEGACY_INDUSTRY_NAME_ALIASES[normalized] ?? name.trim();
  const found = MOCK_INDUSTRIES.find(
    (industry) => industry.name.toLowerCase() === canonical.toLowerCase(),
  );
  return found ?? { id: MOCK_INDUSTRY_OTHER.id, name: canonical };
}

export function mockIndustryDtosFromNames(names: readonly string[]): IndustryDto[] {
  return names.map((name) => mockIndustryDtoByName(name));
}
